import { Directive, ElementRef, HostListener, inject, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

import { isUndefined } from 'lodash-es';
import { DateTime } from 'luxon';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[redTextAreaLogs]',
  standalone: false
})
export class TextAreaLogsDirective implements OnInit, OnDestroy {
  private elementRef = inject(ElementRef);
  private ngControl = inject(NgControl);

  private initialValue?: string;
  private currentValue?: string;
  private currentValueChangeSubscription?: Subscription;

  ngOnInit() {
    const view = this.ngControl?.valueAccessor;

    if (view) {
      view.registerOnChange((value: string) => {
        this.currentValue = value;
      });
    }
  }

  @HostListener('ionFocus', []) onIonFocus() {
    this.currentValue = isUndefined(this.currentValue) ? this.ngControl?.control?.value : this.currentValue;
    this.initialValue = this.currentValue;

    const latestNotesDate = DateTime.now()
      .setLocale(navigator?.language ?? 'en-US')
      .toFormat('MM/dd/yyyy, h:mm:ss a');
    let notes = `${latestNotesDate}: `;
    if (this.currentValue) {
      notes += `\n\n${this.currentValue}`;
    }

    this.ngControl?.control?.setValue(notes);
    this.ngControl?.valueAccessor?.writeValue(notes);

    setTimeout(async () => {
      const textarea = await this.elementRef.nativeElement.getInputElement();
      textarea.setSelectionRange(latestNotesDate.length + 2, latestNotesDate.length + 2);
    });
  }

  @HostListener('ionBlur', []) onIonBlur() {
    this.currentValue = isUndefined(this.currentValue) ? this.ngControl?.control?.value : this.currentValue;

    let notes = this.currentValue;

    const regex = /^(\d{2}\/){2}\d{4},\s(\d{2}:){3}\s*($|\n{2}.*)/;

    if (!isUndefined(notes) && regex.test(notes)) {
      notes = notes.replace(/^(\d{2}\/){2}\d{4},\s(\d{2}:){3}\s*\n{2}/, '');
    }

    this.ngControl?.control?.setValue(notes);
    this.ngControl?.valueAccessor?.writeValue(notes);
    if (this.initialValue !== this.currentValue) {
      this.ngControl?.control?.markAsDirty();
    }
  }

  ngOnDestroy() {
    if (this.currentValueChangeSubscription) {
      this.currentValueChangeSubscription.unsubscribe();
    }
  }
}
